import { NgModule } from '@angular/core';
import { HlmAutocomplete } from './lib/hlm-autocomplete';
import { HlmAutocompleteEmpty } from './lib/hlm-autocomplete-empty';
import { HlmAutocompleteGroup } from './lib/hlm-autocomplete-group';
import { HlmAutocompleteItem } from './lib/hlm-autocomplete-item';
import { HlmAutocompleteList } from './lib/hlm-autocomplete-list';
import { HlmAutocompleteSearch } from './lib/hlm-autocomplete-search';
import { HlmAutocompleteSearchInput } from './lib/hlm-autocomplete-search-input';
import { HlmAutocompleteTrigger } from './lib/hlm-autocomplete-trigger';

export * from './lib/hlm-autocomplete';
export * from './lib/hlm-autocomplete-empty';
export * from './lib/hlm-autocomplete-group';
export * from './lib/hlm-autocomplete-item';
export * from './lib/hlm-autocomplete-list';
export * from './lib/hlm-autocomplete-search';
export * from './lib/hlm-autocomplete-search-input';
export * from './lib/hlm-autocomplete-trigger';
export * from './lib/hlm-autocomplete.token';

export const HlmAutocompleteImports = [
  HlmAutocomplete,
  HlmAutocompleteEmpty,
  HlmAutocompleteGroup,
  HlmAutocompleteItem,
  HlmAutocompleteList,
  HlmAutocompleteSearch,
  HlmAutocompleteSearchInput,
  HlmAutocompleteTrigger,
] as const;

@NgModule({
  imports: [...HlmAutocompleteImports],
  exports: [...HlmAutocompleteImports],
})
export class HlmAutocompleteModule {}
